<template>

    <b-modal id="writingReportCard" title="ライティングレポート" ok-only ok-title="閉じる" size="xl"
        dialog-class="custom-wide-modal" modal-class="agent-netenglish-modal">

        <div class="card esi-card mt-4">
            <div class="card-header esi-card-header">
                ライティングレポート
            </div>
            <div class="card-body esi-card-body overflow-auto">

                <div v-if="loading">読み込み中...</div>
                <div v-if="error">{{ error }}</div>

                <div v-if="reports.length">

                    <table cellspacing="0" cellpadding="0" class="table table-striped" width="100%">
                        <thead>
                            <tr>
                                <th>レッスン日時</th>
                                <th>コース</th>
                                <th>教材</th>
                                <th>科目</th>
                                <th>評価</th>
                                <th>作成者</th>
                                <th>アップロードファイル</th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="report in reports" :key="'report-' + report.id">

                                <td>{{ formatESIDateTime(report.created_at) }}</td>
                                <td><span v-if="report.lesson_course">{{ report.lesson_course }}</span></td>
                                <td><span v-if="report.lesson_material">{{ report.lesson_material }}</span></td>
                                <td><span v-if="report.lesson_subject">{{ report.lesson_subject }}</span></td>
                                <td><span v-if="report.grade">{{ report.grade }}</span></td>

                                <td><span v-if="report.created_by">{{ report.created_by }}</span></td>

                                <td>
                                    <span v-if="report.url">
                                        <button class="btn btn-primary btn-sm"
                                            @click="downloadFile(report.url)">ダウンロード</button>
                                    </span>
                                </td>


                                <!--<td><span v-if="report.file_path">{{ report.file_path  }}</span></td>-->
                                <!-- sample format: storage/uploads/report_files/1724844683_F-117_Nighthawk_Front.jpg -->


                            </tr>
                        </tbody>
                    </table>

                    <!-- Pagination Controls -->
                    <div v-if="lastPage > 1" class="pagination">
                        <button class="btn btn-sm mr-1" type="button" disabled>ページ {{ currentPage }} / {{ lastPage }}</button>
                        <button type="button" @click="prevPage" :disabled="currentPage === 1"
                            class="btn btn-primary btn-sm mr-1">前へ</button>
                        <button v-for="page in pageNumbers" :key="page" type="button"
                            :class="{ active: currentPage === page }"
                            class="mr-1 btn btn-primary btn-sm" @click="goToPage(page)">
                            {{ page }}
                        </button>
                        <button type="button" @click="nextPage" :disabled="currentPage === lastPage"
                            class="btn btn-primary btn-sm mr-1">次へ</button>

                    </div>
                </div>
                <div v-else>
                    <span v-if="loading == false">現在、表示できるライティングレポートはありません。</span>
                </div>

            </div>
        </div>

    </b-modal>

</template>

<style>
.custom-wide-modal {
    max-width: 95%;
    width: 95%;
}
</style>


<style scoped>
.card-body.overflow-auto {
    overflow: auto;
}

.pagination {
    display: inline-block !important;
}
</style>

<script>
export default {
    props: {
        firstname: String,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            reports: [],

            loading: false,
            error: null,
            currentPage: 1,
            lastPage: 1,
            perPage: 10, // Adjust per page if needed
            member: null,

            pageNumbers: [] // Array to store limited page numbers
        };
    },
    mounted() {

    },
    methods: {
        getExtension(str) {
            const index = str.lastIndexOf(".");
            return index !== -1 ? str.substring(index + 1) : "";
        },
        baseName(str) {
            var base = new String(str).substring(str.lastIndexOf('/') + 1);
            if (base.lastIndexOf(".") != -1)
                base = base.substring(0, base.lastIndexOf("."));
            return base;
        },
        async downloadFile(fileUrl) {
            const downloadUrl = `${window.location.origin}/admin/download-file?file=${encodeURIComponent(fileUrl)}`;

            // Create a hidden anchor element
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileUrl.split('/').pop(); // Optional: set the filename for the download

            // Append the link to the DOM
            document.body.appendChild(link);

            // Trigger the click event
            link.click();

            // Remove the link after triggering the download
            document.body.removeChild(link);
        },
        reset() {
            this.reports = [],

                this.loading = false;
            this.error = null;
            this.currentPage = 1;
            this.lastPage = 1;
            this.perPage = 10;
            this.member = null;
        },
        openWritingReportCard(member) {

            this.member = member;
            this.$bvModal.show('writingReportCard');
            this.getReportCards();
        },
        async getReportCards(page = 1) {
            this.loading = true;
            this.currentPage = page;

            this.transactions = [];

            axios.post("/api/getWritingReportCards?api_token=" + this.api_token, {
                method: "POST",
                agentUserID: this.$props.agent_user_id,
                memberID: this.member,
                page: this.currentPage,
                per_page: this.perPage
            }).then(response => {

                if (response.data.success === false) {
                    alert(response.data.message);
                } else {
                    this.reports = response.data.reports.data;
                    this.lastPage = response.data.reports.last_page;
                    this.updatePageNumbers();
                }

                this.loading = false;

            }).catch(function (error) {
                alert("Error " + error);
            });
        },
        goToPage(num) {
            this.getReportCards(num);
        },
        nextPage() {
            if (this.currentPage < this.lastPage) {
                this.getReportCards(this.currentPage + 1);
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.getReportCards(this.currentPage - 1);
            }
        },

        removeUnderscore(string) {
            return string.replace(/_/g, ' '); // Replaces underscores with spaces
        },

        formatESIDateTime(dateString) {
            const date = new Date(dateString);

            // Convert to JST (Japan Standard Time)
            const jstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000); // Adjust UTC to JST (+9 hours)

            // Check if the hour is "00" (in JST)
            if (jstDate.getHours() === 0) {
                // Subtract 1 day and set hour to 24
                jstDate.setDate(jstDate.getDate() - 1);
                return `${jstDate.getFullYear()}年 ${String(jstDate.getMonth() + 1).padStart(2, '0')}月 ${String(jstDate.getDate()).padStart(2, '0')}日 24:${String(jstDate.getMinutes()).padStart(2, '0')}:${String(jstDate.getSeconds()).padStart(2, '0')}`;
            }

            // Format normally
            return `${jstDate.getFullYear()}年 ${String(jstDate.getMonth() + 1).padStart(2, '0')}月 ${String(jstDate.getDate()).padStart(2, '0')}日 ${String(jstDate.getHours()).padStart(2, '0')}:${String(jstDate.getMinutes()).padStart(2, '0')}:${String(jstDate.getSeconds()).padStart(2, '0')}`;
        },

        updatePageNumbers() {

            const maxPagesToShow = 15; // Max number of pages to show
            const halfRange = Math.floor(maxPagesToShow / 2);

            // Adjust start and end page to make sure they are within bounds
            let startPage = this.currentPage - halfRange;
            let endPage = this.currentPage + halfRange;

            // Ensure start page is at least 1
            if (startPage < 1) {
                startPage = 1;
                endPage = Math.min(maxPagesToShow, this.lastPage); // Make sure endPage doesn't exceed lastPage
            }

            // Ensure end page doesn't exceed lastPage
            if (endPage > this.lastPage) {
                endPage = this.lastPage;
                startPage = Math.max(1, this.lastPage - maxPagesToShow + 1); // Make sure startPage doesn't go below 1
            }

            // Generate the list of page numbers to display
            this.pageNumbers = [];

            for (let i = startPage; i <= endPage; i++) {
                this.pageNumbers.push(i);
            }

        }

    },

};

</script>